<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { surveysApi, type Survey } from '@/services/api/surveys';
import { useAppConfirm } from '@/composables/confirm';
import ProjectsSubNav from './ProjectsSubNav.vue';

const route = useRoute();
const surveys = ref<Survey[]>([]);
const confirm = useAppConfirm();

function projectIdParam(): string {
  const raw = route.params.id;
  return Array.isArray(raw) ? (raw[0] ?? '') : raw ?? '';
}

async function reload(): Promise<void> {
  surveys.value = await surveysApi.index(projectIdParam());
}

async function remove(survey: Survey): Promise<void> {
  const ok = await confirm({
    header: 'Remove Completed Form',
    message: 'Are you sure you want to remove this completed form?',
  });
  if (!ok) return;
  await surveysApi.remove(projectIdParam(), survey.id);
  surveys.value = surveys.value.filter((s) => s.id !== survey.id);
}

onMounted(reload);
</script>

<template>
  <div>
    <ProjectsSubNav :project-id="projectIdParam()" />
    <section class="resource">
      <h1>Project Data</h1>
      <ul class="resource__list">
        <li v-for="s in surveys" :key="s.id">
          <span>Survey #{{ s.id }}</span>
          <button type="button" @click="remove(s)">Remove</button>
        </li>
      </ul>
      <p v-if="surveys.length === 0">No completed surveys.</p>
    </section>
  </div>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
